import { setDocumentTitle } from "@/lib/documentTitle";
// main.tsx
import { useEffect } from "react";
import { MacroKeywordCard } from "./card";
import { MacroKeywordNew } from "./new";
import { Route, Routes } from "react-router-dom";

import { MacroKeywordsTable } from "./table";

export default function MacroKeyword() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Mots-clés macro");
  }, []);

  return (
    <Routes>
      <Route index element={<MacroKeywordsTable />} />
      <Route path="/new" element={<MacroKeywordNew />} />
      <Route path=":id" element={<MacroKeywordCard />} />
    </Routes>
  );
}
